/**
 * Deux teintes que `theme.js` ne porte pas encore sur cette branche.
 *
 * `errorStrong` et `warningDark` arrivent avec une autre PR ; en attendant, s'y
 * référer via `theme.colors` renvoie `undefined` — et une couleur indéfinie se
 * rend en noir, ce qui fait passer un avertissement pour du texte ordinaire.
 * On les déclare ici aux mêmes valeurs, à retirer dès que le thème les expose.
 *
 * Elles existent parce que `error` et `warning` sont trop clairs pour du texte
 * posé sur leurs propres fonds pâles.
 */

/** Rouge lisible sur fond blanc comme sur `errorLight`. */
export const DANGER = "#cc2f36"

/** Ambre lisible sur fond blanc comme sur `warningLight`. */
export const CAUTION = "#a8641f"
